import { useQuery } from 'react-query'
// import { consoleLog } from '../util'

export const useReactQuery = (useReactQueryObject, onSuccess) => {
  //   const queryId = Array.isArray(useReactQueryObject.payloadDetails.queryId) ? [...useReactQueryObject.payloadDetails.queryId] : [useReactQueryObject.payloadDetails.queryId]
  const queryId = useReactQueryObject.payloadDetails.queryId
  //   consoleLog('queryId ', queryId)
  return useQuery(
    queryId,
    // () => fetchSuperHeros(payloadDetails),
    // () => axios.get(payloadDetails.url),
    () => useReactQueryObject.payloadDetails.urlFunc(useReactQueryObject.payloadDetails.payload),
    {
      cacheTime: 0, // Data will be cached for X time
      staleTime: 0, // This will not even hit the Server to get latest data
      refetchOnMount: false, // This load data once and after that, there wont be any API HIT // default its true
      refetchOnWindowFocus: false, // Don't want to load any data on window focus
      enabled: true, // This will be stopped on component load and will happen onClick of a button
      onSuccess,
      ...useReactQueryObject?.queryDetails
    }
  )
}

// HOW TO USE
/*
  const useReactQueryObject = {
    payloadDetails: {
        queryId: [props.InsightsElementType, props.InsightsElementId],
        urlFunc: ReportsService.getSegmentOfSegmentOverviewElement,
        payload: { insightsElementId:props.InsightsElementId }
    }
  }
  const { data, isLoading, isSuccess, isError, error, refetch } = useReactQuery(useReactQueryObject)
  // /////////////////////////////////////////////////////////////
  const onSuccessFunc = (resp) => {
    generateBuyerMaturityData(resp, hasTabs)
  }
  useEffect(() => {
      if(isSuccess && data?.length) onSuccessFunc(data)
  }, [isSuccess, data])
*/
